import { render, staticRenderFns } from "./CreateTransactionDeskTransactionModal.vue?vue&type=template&id=298b6ac1&scoped=true&lang=pug"
import script from "./CreateTransactionDeskTransactionModal.vue?vue&type=script&lang=js"
export * from "./CreateTransactionDeskTransactionModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTransactionDeskTransactionModal.vue?vue&type=style&index=0&id=298b6ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b6ac1",
  null
  
)

export default component.exports